import { useRoute } from "@bcm-dev/bcms-vite";
import { UIButton } from "components/ui";

import "./styles.css";

export default function AdvancedAlertsContent(props) {
    const navigate = useRoute();

    const onManageAlerts = evt => navigate("/advancedAlerts/manageAlerts");
    const onManageRecipients = evt => navigate("/advancedAlerts/manageRecipients");

    return (
        <div className="advanced-alerts-content">
            <p className="page-subtitle">Manage Alerts and Recipients</p>

            <div className="flex-container flex-horizontal button-container vertical-stack">
                <div className="flex-container flex-vertical set-width">
                    <UIButton className="primary-button" text="Manage Alerts" onClick={ onManageAlerts } />
                    <UIButton className="primary-button" text="Manage Recipients" onClick={ onManageRecipients } />
                </div>

                <div className="flex-width" />
            </div>
        </div>
    );
}